(function () {
  const DEFAULT_START = 40;
  const DEFAULT_DURATION = 1200;
  const SELECTOR = ".stat__value";
  const toNum = s => parseFloat(String(s).replace(/[^\d.]/g, "")) || 0;

  const inViewport = (el) => {
    const r = el.getBoundingClientRect();
    return r.bottom > 0 && r.right > 0 &&
           r.top < (window.innerHeight || document.documentElement.clientHeight) &&
           r.left < (window.innerWidth || document.documentElement.clientWidth);
  };

  function animate(node, start, target, duration, suffix) {
    const t0 = performance.now();
    const step = now => {
      const p = Math.min(1, (now - t0) / duration);
      node.textContent = Math.round(start + (target - start) * p) + suffix;
      if (p < 1) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  }

  function init(container) {
    const root = (container && typeof container.querySelectorAll === "function") ? container : document;
    const nodes = Array.from(root.querySelectorAll(SELECTOR));
    if (!nodes.length) return;

    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      nodes.forEach(n => {
        const suffix = n.dataset.suffix ?? "%";
        const target = n.dataset.target ? toNum(n.dataset.target) : toNum(n.textContent);
        n.textContent = target + suffix;
      });
      return;
    }

    const meta = new WeakMap();
    nodes.forEach(n => {
      const suffix   = n.dataset.suffix ?? "%";
      const start    = n.dataset.start ? toNum(n.dataset.start) : DEFAULT_START;
      const target   = n.dataset.target ? toNum(n.dataset.target) : toNum(n.textContent);
      const duration = n.dataset.duration ? parseInt(n.dataset.duration, 10) : DEFAULT_DURATION;
      n.textContent = start + suffix;             // prime so it has size
      meta.set(n, { start, target, duration, suffix, done: false });
    });

    const kick = n => {
      const m = meta.get(n);
      if (m && !m.done) { m.done = true; animate(n, m.start, m.target, m.duration, m.suffix); }
    };

    // Immediate check
    nodes.forEach(n => { if (inViewport(n)) kick(n); });

    // Fallback scroll/resize
    const pending = new Set(nodes.filter(n => !(meta.get(n)?.done)));
    const onScroll = () => {
      pending.forEach(n => { if (inViewport(n)) { kick(n); pending.delete(n); } });
      if (!pending.size) {
        window.removeEventListener("scroll", onScroll, true);
        window.removeEventListener("resize", onScroll, true);
      }
    };
    if (pending.size) {
      window.addEventListener("scroll", onScroll, true);
      window.addEventListener("resize", onScroll, true);
      setTimeout(onScroll, 0);
    }

    // IntersectionObserver (preferred)
    if ("IntersectionObserver" in window) {
      const io = new IntersectionObserver((entries, obs) => {
        entries.forEach(e => {
          if (e.isIntersecting) { kick(e.target); obs.unobserve(e.target); pending.delete(e.target); }
        });
      }, { threshold: 0, root: null, rootMargin: "0px 0px -10% 0px" });
      nodes.forEach(n => io.observe(n));
    }
  }

  document.addEventListener("DOMContentLoaded", () => init()); // <-- call with no args
  window.initStatCounters = init; // call with a container if you inject HTML later
})();